import { QueryCache, QueryClient, MutationCache } from "@tanstack/react-query";
import { reportApiError } from "@/lib/report-error";
import { trackApiError } from "@/lib/telemetry";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      reportApiError(error, { source: "react-query", kind: "query", key: query.queryKey });
      trackApiError(error);
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _vars, _ctx, mutation) => {
      reportApiError(error, {
        source: "react-query",
        kind: "mutation",
        key: mutation.options.mutationKey,
      });
      trackApiError(error);
    },
  }),
});
